import React from "react"
import { ErrorBoundary } from "../ErrorBoundary"
import { ProfileForm } from "./ProfileForm"
import { DangerZone } from "./DangerZone"

// Settings → Profile page. Standalone mount (own route/URL); the sidebar nests
// it under Settings. Wraps the shared ProfileForm and the GDPR Danger Zone.
export default function SettingsProfileApp({
  settingsPath, profile, copy, isOwner, userAccountPath, partnerAccountPath, dangerCopy,
}) {
  return (
    <ErrorBoundary>
      <div className="space-y-10">
        <div className="space-y-6">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{copy.title}</h1>
          <ProfileForm profile={profile} settingsPath={settingsPath} copy={copy} />
        </div>
        <DangerZone
          isOwner={isOwner}
          partnerName={profile.name}
          userAccountPath={userAccountPath}
          partnerAccountPath={partnerAccountPath}
          copy={dangerCopy}
        />
      </div>
    </ErrorBoundary>
  )
}
